<template>
  <div>救援事故列表</div>
</template>

<script>
export default {
name:'',
data(){
return {};
}
};

</script>
<style  lang="scss" scoped>
</style>